function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { BIRMINGHAM_MIDSHIRES, BOS, HALIFAX, LLOYDS, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm-1.56 7.08c0-.84.36-1.44 1.44-1.44 1.2 0 1.56.6 1.56 1.44v.12c0 .84-.36 1.44-1.56 1.44-1.2 0-1.44-.6-1.44-1.44v-.12zm3.12 11.52h-3v-9h3v9z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,2.83333333 C6.93738979,2.83333333 2.83333333,6.93738979 2.83333333,12 C2.83333333,17.0626102 6.93738979,21.1666667 12,21.1666667 C17.0626102,21.1666667 21.1666667,17.0626102 21.1666667,12 C21.1666667,6.93738979 17.0626102,2.83333333 12,2.83333333 Z M13,10 L13,18 L11,18 L11,10 L13,10 Z M12,6 C12.5128358,6 12.9355072,6.38272018 12.9932723,6.88266744 L13,7 C13,7.51283584 12.6172798,7.93550716 12.1173326,7.99327227 L12,8 C11.4477153,8 11,7.55613518 11,7 C11,6.48716416 11.3827202,6.06449284 11.8826674,6.00672773 L12,6 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.999 4.734c-1.22 0-1.593.629-1.593 1.573v.157c0 .964.373 1.595 1.593 1.595s1.594-.63 1.594-1.595v-.157c0-.944-.375-1.573-1.594-1.573zM12 0C5.375 0 0 5.373 0 12c0 6.63 5.375 12 12 12 6.629 0 12-5.373 12-12S18.63 0 12 0zm-1.457 19.108h2.892V9.565h-2.892v9.543z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.0527 18H12.9473V10.7368H11.0527V18ZM12 8.57491C12.2891 8.57491 12.5314 8.47714 12.7269 8.2816C12.9225 8.08606 13.0202 7.84376 13.0202 7.55468C13.0202 7.26563 12.9225 7.02332 12.7269 6.82777C12.5314 6.63223 12.2891 6.53446 12 6.53446C11.7109 6.53446 11.4686 6.63223 11.2731 6.82777C11.0775 7.02332 10.9798 7.26563 10.9798 7.55468C10.9798 7.84376 11.0775 8.08606 11.2731 8.2816C11.4686 8.47714 11.7109 8.57491 12 8.57491ZM12.0021 24C10.3424 24 8.78236 23.6851 7.32198 23.0552C5.86157 22.4253 4.59123 21.5704 3.51096 20.4906C2.43066 19.4108 1.57543 18.141 0.945255 16.6813C0.315085 15.2215 0 13.6618 0 12.0021C0 10.3424 0.314948 8.78236 0.944845 7.32198C1.57474 5.86157 2.42959 4.59123 3.50938 3.51096C4.58919 2.43066 5.85897 1.57543 7.31872 0.945255C8.77845 0.315085 10.3382 0 11.9979 0C13.6576 0 15.2176 0.314948 16.678 0.944844C18.1384 1.57474 19.4088 2.42959 20.489 3.50938C21.5693 4.58919 22.4246 5.85897 23.0547 7.31872C23.6849 8.77845 24 10.3382 24 11.9979C24 13.6576 23.6851 15.2176 23.0552 16.678C22.4253 18.1384 21.5704 19.4088 20.4906 20.489C19.4108 21.5693 18.141 22.4246 16.6813 23.0547C15.2215 23.6849 13.6618 24 12.0021 24ZM12 22.1053C14.8211 22.1053 17.2105 21.1263 19.1684 19.1684C21.1263 17.2105 22.1053 14.8211 22.1053 12C22.1053 9.17894 21.1263 6.78946 19.1684 4.83156C17.2105 2.87366 14.8211 1.89471 12 1.89471C9.17894 1.89471 6.78946 2.87366 4.83156 4.83156C2.87366 6.78946 1.89471 9.17894 1.89471 12C1.89471 14.8211 2.87366 17.2105 4.83156 19.1684C6.78946 21.1263 9.17894 22.1053 12 22.1053Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM14.878 16.877C13.695 17.934 12.307 18.694 11.502 18.898C10.638 19.117 9.945 19.047 9.878 18.052C9.827 17.312 10.453 14.774 10.809 13.331C10.932 12.83 11.024 12.461 11.043 12.345C11.106 11.966 10.275 12.36 9.587 12.726C9.387 12.832 9.136 12.743 9.039 12.538C8.957 12.368 9.006 12.163 9.157 12.049C10.347 11.155 11.83 10.309 13.088 9.973C13.812 9.78 14.227 10.017 14.253 10.901C14.27 11.512 13.708 13.626 13.327 15.058C13.155 15.703 13.021 16.21 12.992 16.379C12.856 17.181 13.761 16.68 14.417 16.265C14.586 16.158 14.809 16.199 14.928 16.361C15.043 16.519 15.025 16.745 14.879 16.875L14.878 16.877ZM13.254 8.131C12.455 8.131 11.872 7.646 11.872 6.801C11.872 5.956 12.569 5 13.721 5C14.125 5 15.124 5.261 15.124 6.372C15.124 7.483 14.051 8.131 13.254 8.131Z",
    fill: "currentColor"
  }));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11.9997C0 5.37273 5.37232 0 12 0C18.6277 0 24 5.37273 24 12.0003C24 18.6273 18.6277 24 12 24C5.37232 24 0 18.6273 0 11.9997ZM13.4992 9.99583V18.9958C13.4992 19.5838 12.6885 19.7458 12.1658 19.7458C11.6432 19.7458 10.8325 19.5838 10.8325 18.9958V11.4958L10.4698 11.0458C9.90982 10.9618 9.49915 10.4158 9.49915 9.78583V9.65983C9.49915 9.07183 10.3098 8.49583 10.8325 8.49583H12.1658C12.6885 8.49583 13.4992 9.40783 13.4992 9.99583ZM11.9868 3.99583C12.8545 3.99583 13.4992 4.62998 13.4992 5.50803C13.4992 6.33729 12.8545 6.99583 11.962 6.99583C11.119 6.99583 10.4992 6.33729 10.4992 5.50803C10.4992 4.65437 11.1438 3.99583 11.9868 3.99583Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useTheme } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme() || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.information) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.information;
  } else {
    switch (brand) {
      case BOS:
        svg = BosIcon;
        break;
      case BIRMINGHAM_MIDSHIRES:
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}